import type { ReactNode } from "react";

/**
 * The frame both states share: the brand mark, a heading, and whatever the
 * state puts below it. One component so the card does not drift between "sign
 * in" and "already signed in", which are two renders of the same page.
 */
export function AuthCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-adriatic-deep px-4 py-10">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl shadow-black/30">
        <div className="text-center">
          {/* The primary, coloured logo on a white card, which is why the card
              is white: a reversed variant would be a second asset to keep in
              step with the brand for no gain. */}
          <img
            src="/brand/logo.svg"
            alt="Acquire Intelligence"
            width={148}
            height={41}
            className="mx-auto h-10 w-auto"
          />

          <h1 className="mt-6 text-xl font-semibold text-adriatic-deep">{title}</h1>
          <p className="mt-1 text-sm text-adriatic-mid">{subtitle}</p>
        </div>

        <div className="mt-7">{children}</div>

        <p className="mt-8 text-center text-xs text-adriatic-mid/70">
          ACQUIRE INTELLIGENCE&trade; AI Labs
        </p>
      </div>
    </main>
  );
}
